import styled from 'styled-components';
import { useState } from 'react';
import { WaringModal } from '../../modal/WaringModal';
import { goToTournament, mobileQuery } from '../../../utils';
import { ImageUtils } from '../../../utils/ImageUtils';

export const InActiveTicket = ({
  goOnlineTab,
  ticketCnt,
}: {
  goOnlineTab: () => void;
  ticketCnt: number;
}) => {
  const [showWarningModal, setShowWarningModal] = useState(false);

  return (
    <>
      <Container>
        <ImgContainer>
          <QuestionIcon onClick={() => setShowWarningModal(true)} />
          <TicketImg src={ImageUtils.ParticipateInfo} alt="ParticipateInfo" />
        </ImgContainer>
        <CountContainer>
          <CountCnt>
            {ticketCnt}
            <CountUnit>장</CountUnit>
          </CountCnt>
          <RemainContainer>
            <RemainText>남은 메인 이벤트 참가 티켓</RemainText>
          </RemainContainer>
          <RemainSubText>
            참가 티켓은 <span>12 TO 1</span> 방식으로 지급되며,
            <br />
            250장 모두 지급되면 새틀라이트가 조기종료 됩니다.
          </RemainSubText>

          <NeedTicketContainer>
            <NeedTicketSubText>메인 이벤트 참가 티켓 획득 여부</NeedTicketSubText>
            <NeedTicketText>참가 티켓을 아직 획득하지 못했습니다.</NeedTicketText>
            <NeedTicketSubText>새틀라이트를 통해 티켓을 획득해주세요!</NeedTicketSubText>
          </NeedTicketContainer>
        </CountContainer>
      </Container>
      <BottomTabContainer>
        <CheckParticipateBtn onClick={goOnlineTab}>
          새틀라이트
          <br />
          참가 방법
        </CheckParticipateBtn>
        <GoTournamentBtn onClick={goToTournament}>새틀라이트 참가하기</GoTournamentBtn>
      </BottomTabContainer>
      <WaringModal visible={showWarningModal} close={() => setShowWarningModal(false)} />
    </>
  );
};

const ImgContainer = styled.div`
  position: relative;
`;

const TicketImg = styled.img`
  width: 515px;

  ${mobileQuery} {
    width: 352px;
  }
`;

const Container = styled.div`
  position: relative;
  padding-bottom: 180px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media screen and (max-width: 720px) {
    padding-bottom: 130px;
  }
`;

const CountContainer = styled.div`
  position: absolute;
  top: 10px;
  width: 100%;
  text-align: center;
`;

const RemainContainer = styled.div`
  width: 400px;
  margin: 0 auto;
  margin-bottom: 9px;

  border-top: 1.5px solid rgba(0, 0, 0, 0.5);

  background: rgba(0, 0, 0, 0.1);
  height: 35px;

  ${mobileQuery} {
    padding-top: 2px;
    width: 200px;
    height: 32px;
  }
`;

const RemainText = styled.h3`
  font-weight: 800;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.7);

  ${mobileQuery} {
    font-size: 16px;
    line-height: 22px;
  }
`;

const RemainSubText = styled.h4`
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.03em;
  color: rgba(0, 0, 0, 0.5);
  font-weight: 500;

  span {
    font-weight: 800;
  }
  ${mobileQuery} {
    font-size: 14px;
    line-height: 20px;
  }
`;

const NeedTicketContainer = styled.div`
  margin-top: 70px;

  ${mobileQuery} {
    margin-top: 30px;
  }
`;

const NeedTicketText = styled.h3`
  font-weight: 600;
  font-size: 32px;
  line-height: 36px;
  letter-spacing: -0.02em;

  color: #000000;

  ${mobileQuery} {
    font-size: 18px;
    line-height: 24px;
  }
`;
const NeedTicketSubText = styled.h4`
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.02em;

  color: rgba(0, 0, 0, 0.5);
  margin: 10px 0;

  ${mobileQuery} {
    margin: 0;
    font-size: 15px;
    line-height: 24px;
  }
`;

const CountCnt = styled.p`
  font-size: 140px;
  line-height: 150px;
  font-weight: bold;

  ${mobileQuery} {
    font-size: 96px;
    line-height: 131px;
  }
`;

const CountUnit = styled.span`
  font-size: 96px;
  ${mobileQuery} {
    font-size: 30px;
    line-height: 32px;
  }
`;

const QuestionIcon = styled.div`
  position: absolute;
  width: 50px;
  height: 50px;
  right: 30px;
  top: 40px;
  cursor: pointer;
  z-index: 1;
  background-image: url(${ImageUtils.QuestionIcon});

  ${mobileQuery} {
    width: 25px;
    height: 25px;
    right: 10px;
    top: 20px;
    background-size: contain;
  }
`;

const BottomTabContainer = styled.div`
  position: fixed;
  bottom: 0;
  z-index: 10;
  width: 100%;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
`;

const CheckParticipateBtn = styled.button`
  height: 70px;
  width: 30%;
  left: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  background-color: #a91f52;

  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 18px;

  color: #ffffff;
`;

const GoTournamentBtn = styled.button`
  left: 30%;
  height: 70px;
  width: 70%;
  cursor: pointer;
  background-color: #7e0f45;

  font-weight: 900;
  font-size: 21px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #ffffff;
`;
